import { init, h } from 'snabbdom';

import { VNode, VNodeData } from 'snabbdom/vnode';

import attributes from 'snabbdom/modules/attributes';
import props from 'snabbdom/modules/props';
import style from 'snabbdom/modules/style';
import eventlisteners from 'snabbdom/modules/eventlisteners';
import classModule from 'snabbdom/modules/class';

export { h };
export const patch = init([
	attributes,
	props,
	style,
	eventlisteners,
	classModule,
]);

const snabbdom = {
	h,
	// Configure the required modules here,
	patch,
};

declare global {
	interface Window {
		snabbdom : typeof snabbdom;
	}
	namespace SnabbdomPragma {
		type Children = VNode[] | VNode | string | number;
		type CircularChildren = Children | Children[];

		type Component = (props : VNodeData, children : CircularChildren[]) => VNode;

		export function createElement(
			sel : string | Component,
			data : null | VNodeData,
			...children : CircularChildren[]
		) : VNode;
	}
	namespace JSX {
		type Element = any;
		interface IntrinsicElements {
			[elemName : string] : VNodeData
		}
	}
}

window.snabbdom = snabbdom;

export default snabbdom;



// WEBPACK FOOTER //
// typescript://../clientlibs/js/bootstrap/load-snabbdom.ts